import { useWorkOrderParser } from "./useWorkOrderParser";

export default useWorkOrderParser;
